module.exports = __webpack_public_path__ + "assets/toolbar-widget-icon.22ca8189.svg";